// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skills-section {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  font-size: .8rem;

}

.skills-category {
  margin-bottom: 20px;
  padding: 0 20px;
}

.category-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.icon svg {
  margin-bottom: -2px; /* Adjust icon alignment */
}

.skills-subcategory h4 {
  margin-top: 0;
  margin-bottom: 5px;
  padding: 0 10px;
}

.skills-subcategory p {
  margin-top: 0;
  padding: 0 10px;
}

@media (max-width: 768px) {
  .skills-section {
    padding: 0 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/SkillsSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".skills-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0 20px;\r\n  font-size: .8rem;\r\n\r\n}\r\n\r\n.skills-category {\r\n  margin-bottom: 20px;\r\n  padding: 0 20px;\r\n}\r\n\r\n.category-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.icon svg {\r\n  margin-bottom: -2px; /* Adjust icon alignment */\r\n}\r\n\r\n.skills-subcategory h4 {\r\n  margin-top: 0;\r\n  margin-bottom: 5px;\r\n  padding: 0 10px;\r\n}\r\n\r\n.skills-subcategory p {\r\n  margin-top: 0;\r\n  padding: 0 10px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .skills-section {\r\n    padding: 0 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
